import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
function stoofMoreFrontend() {
    if (document.querySelector('.stoof-more-button')) {
        let tl = gsap.timeline({ });
        document.addEventListener('click', (ev) => {
            const matches = ev.target.matches ? ev.target.matches('.stoof-more-button') : ev.target.msMatchesSelector('.stoof-more-button');
            if (!matches) return;

            const button = ev.target;
            const wrapper = ev.target.parentElement;
            const section = wrapper.closest('.stoof-section-block');
            const hidden = wrapper.querySelector('.stoof-more-inner');
            const hiddenHeight = hidden.clientHeight;
            if(!button.classList.contains('stoof-more-button__open')){
                tl.fromTo(hidden, {maxHeight: '35vh'}, {duration: 2, maxHeight: hiddenHeight});

            }else{
                tl.fromTo(hidden, {maxHeight: '100%'}, {duration: 1, maxHeight: '35vh'});
                tl.to(window, {duration: 0.5, scrollTo: section});
            }





            hidden.classList.toggle('stoof-more-inner__show');
            button.classList.toggle('stoof-more-button__open');



        })

    }
}

export default stoofMoreFrontend;